<template>
  <div class="no-scroll">
    <!-- Theme-matched Snackbar -->
    <v-snackbar
      class="pt-6 pr-6"
      style="z-index: 6 !important"
      transition="slide-x-reverse-transition"
      v-model="snackbar"
      timeout="5000"
      :value="true"
      :color="snackbarclr"
      absolute
      outlined
      top
      right
    >
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>

    <LayOut />

    <v-container class="px-md-6 pt-14 no-scroll" fluid fill-height style="height: 100vh; overflow: scroll">
      <!-- 1. Top Summary Cards Row -->
      <v-row no-gutters class="pt-sm-2 pb-sm-4">
        <v-col cols="12" sm="6" md="3" class="px-1">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            View / Pending : <b>{{ counts.view ? counts.view : 0 }}</b> <br />
            Total Applications : <b>{{ counts.total ? counts.total : 0 }}</b>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-1">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            E-sign pending : <b>{{ counts.e_signed_pending ? counts.e_signed_pending : 0 }}</b> <br />
            Re-e-sign pending : <b>{{ counts.re_e_signed_pending ? counts.re_e_signed_pending : 0 }}</b>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-1">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            E-signed : <b>{{ counts.e_signed_completed ? counts.e_signed_completed : 0 }}</b> <br />
            Re-e-signed : <b>{{ counts.re_e_signed_completed ? counts.re_e_signed_completed : 0 }}</b>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-1">
          <v-card width="100%" class="elevation-0 rounded-lg px-4 py-2 text-center" outlined>
            Completed : <b>{{ counts.completed ? counts.completed : 0 }}</b> <br />
            Rejected : <b>{{ counts.rejected ? counts.rejected : 0 }}</b>
          </v-card>
        </v-col>
      </v-row>

      <!-- 2. Data Card & Table -->
      <v-card width="100%" class="elevation-0 rounded-lg mt-auto" outlined>
        <!-- Toolbar Header (tabs stay visible across all tabs) -->
        <v-toolbar dense flat>
          <v-tabs dense v-model="tab" @change="onTabChange">
            <v-tab class="text-none">
              <v-badge :content="viewTabCount" :value="viewTabCount">
                <span> View </span>
              </v-badge>
            </v-tab>
            <v-tab class="text-none">
              <v-badge :content="counts.completed ? counts.completed : 0" :value="counts.completed">
                <span> Complete </span>
              </v-badge>
            </v-tab>
            <v-tab class="text-none">
              <v-badge :content="counts.rejected ? counts.rejected : 0" :value="counts.rejected">
                <span> Reject </span>
              </v-badge>
            </v-tab>
            <!-- <v-tab class="text-none">
              <span> Sharing Ratio </span>
            </v-tab> -->
          </v-tabs>

          <v-spacer></v-spacer>

          <!-- Table filters (hidden on the Sharing Ratio tab) -->
          <template v-if="tab !== 3">
            <!-- Status Filter (multi-select) -->
            <v-select
              v-model="statusFilter"
              :items="statusOptions"
              @change="onStatusChange"
              @click:clear="onStatusChange"
              multiple
              chips
              small-chips
              clearable
              color="#0037B7"
              item-color="#0037B7"
              :disabled="mainloader"
              dense
              class="rounded-lg mr-4"
              style="min-width: 200px; max-width: 280px"
              label="Status filter"
              single-line
              hide-details
            ></v-select>

            <!-- Stage Filter (multi-select) -->
            <v-select
              v-model="stageFilter"
              :items="stageFilterOptions"
              @change="onStageChange"
              @click:clear="onStageChange"
              multiple
              chips
              small-chips
              clearable
              color="#0037B7"
              item-color="#0037B7"
              :disabled="mainloader"
              dense
              class="rounded-lg mr-4"
              style="min-width: 200px; max-width: 280px"
              label="Stage filter"
              single-line
              hide-details
            ></v-select>

            <!-- Date Filter Menu -->
            <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  readonly
                  color="#fb8c00"
                  :disabled="mainloader"
                  dense
                  @click:clear="dateClear"
                  clearable
                  v-model="alldate"
                  class="rounded-lg mr-4"
                  style="min-width: 200px"
                  prepend-inner-icon="mdi-calendar"
                  label="Date filter"
                  single-line
                  hide-details
                ></v-text-field>
              </template>
              <v-card width="580px">
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-date-picker v-model="dateSelect1"></v-date-picker>
                  </v-col>
                  <v-col cols="6">
                    <v-date-picker v-model="dateSelect2" :min="dateSelect1" @input="onDatePickDone"></v-date-picker>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>

            <!-- Search Box -->
            <v-text-field
              color="#fb8c00"
              dense
              v-model="search"
              @input="onSearch"
              clearable
              @click:clear="onSearch"
              class="rounded-lg mr-2"
              style="max-width: 170px"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

            <!-- Refresh Button -->
            <v-btn icon :loading="mainloader" :disabled="mainloader" @click="refreshAll()">
              <v-icon color="#fb8c00">mdi-refresh</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
        <v-divider></v-divider>

        <v-data-table
          v-if="tab !== 3"
          ref="ovrtable"
          height="calc(100vh - 280px)"
          dense
          style="overflow: auto"
          fixed-header
          must-sort
          :search="search"
          :sort-by="[sortByField]"
          :sort-desc="[true]"
          :group-by="groupByField"
          :headers="filteredHeaders"
          :items="itemsWithSno"
          :loading="mainloader"
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
          mobile-breakpoint
          item-key="sno"
        >
          <!-- Table Slots -->
          <template v-slot:[`item.date_time`]="{ item }">
            <span>{{ item.mobileVerifyTime || item.date_time || item.datetime || '-' }}</span>
          </template>

          <template v-slot:[`item.mobile_no`]="{ item }">
            <span>{{ item.mobileNumber || item.mobile_no || '-' }}</span>
          </template>

          <template v-slot:[`item.client_id`]="{ item }">
            <span>{{ item.clientid || item.client_id || '-' }}</span>
          </template>

          <!-- <template v-slot:[`item.regMemberName`]="{ item }">
            <span>{{ item.regMemberName || '-' }}</span>
          </template> -->

          <template v-slot:[`item.client_name`]="{ item }">
            <span class="text-uppercase font-weight-medium">{{ item.Name || item.client_name || item.pan_name || '-' }}</span>
          </template>

          <template v-slot:[`item.client_pan`]="{ item }">
            <span class="text-uppercase">{{ item.PAN || item.client_pan || '-' }}</span>
          </template>

          <template v-slot:[`item.app_status`]="{ item }">
            <span class="black--text">{{ item.app_status || item.changes || '-' }}</span>
          </template>

          <template v-slot:[`item.esigned_datetime`]="{ item }">
            <span>{{ item.esigned_datetime || '-' }}</span>
          </template>

          <template v-slot:[`item.approved_datetime`]="{ item }">
            <span>{{ item.approved_datetime || item.approved_date_time || item.esigned_datetime || '-' }}</span>
          </template>

          <template v-slot:[`item.rejection_date_time`]="{ item }">
            <span>{{ item.rejection_date_time || item.rejection_datetime || '-' }}</span>
          </template>

          <template v-slot:[`item.view`]="{ item }">
            <v-btn small @click="openDetailPanel(item)" color="#0037B7" class="elevation-0 rounded-md">
              <span class="white--text text-none">{{ tab === 0 ? "Verify" : "View" }}</span>
            </v-btn>
          </template>

          <template v-slot:[`item.del`]="{ item }">
            <v-btn small @click="promptDelete(item)" color="#FF1717" class="elevation-0 rounded-md">
              <span class="white--text text-none">Delete</span>
            </v-btn>
          </template>

          <!-- Grouped-by-status header row (like EKYC) -->
          <template v-slot:[`group.header`]="{ group, isOpen, toggle }">
            <td :colspan="filteredHeaders.length" class="text-start">
              <v-btn small icon @click="toggle">
                <v-icon small>{{ isOpen ? "mdi-minus" : "mdi-plus" }}</v-icon>
              </v-btn>
              <span>Status: {{ group }}</span>
              <v-btn small icon @click="removeStatusGroup(group)">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </td>
          </template>

          <template v-slot:no-data>
            <div class="pa-6 text-center grey--text">
              No AP applications found matching criteria.
            </div>
          </template>
        </v-data-table>

        <!-- Sharing Ratio — universal plan control (fetch → edit → generate / update) -->
        <div v-if="tab === 3" class="pa-4" style="height: calc(100vh - 280px); overflow: auto">
          <v-row class="mb-1" align="center">
            <v-col cols="12">
              <h2 class="black--text mb-0">Sharing Ratio</h2>
              <p class="grey--text mb-0">Fetch a client's plan, edit it, then re-assign the changed plan.</p>
            </v-col>
          </v-row>

          <!-- Fetch an existing client's plan into the editable table below -->
          <v-row align="center" class="mb-1">
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="rb_mobile"
                color="#0037B7"
                dense
                outlined
                hide-details
                clearable
                maxlength="10"
                label="Mobile Number"
                class="rounded-lg"
                @input="rb_planFetched = false"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-select
                v-model="rb_status"
                :items="rb_statusItems"
                color="#0037B7"
                item-color="#0037B7"
                dense
                outlined
                hide-details
                label="Status"
                class="rounded-lg"
                @change="rb_planFetched = false"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-btn
                :disabled="!rb_mobile || !rb_status"
                :loading="rb_fetchLoading"
                color="#0037B7"
                class="elevation-0 rounded-lg white--text text-none px-6"
                @click="rbGetPlan"
              >
                Get Plan
              </v-btn>
            </v-col>
          </v-row>

          <!-- Everything below appears only after Get Plan (the fetched client's plan) -->
          <v-card v-if="rb_planFetched" outlined class="elevation-0 rounded-lg overflow-hidden">
            <!-- Client header -->
            <div class="d-flex align-center flex-wrap px-5 py-4" style="background-color: #f7f9fc">
              <v-avatar size="46" color="#0037B7" class="mr-3">
                <span class="white--text font-weight-bold">{{ rbInitials }}</span>
              </v-avatar>
              <div>
                <p class="text-h6 font-weight-bold black--text mb-0 text-uppercase" style="line-height: 1.2">{{ rb_panName || "-" }}</p>
                <p class="grey--text text--darken-1 caption mb-0">
                  {{ rb_clientId || "-" }} <span class="grey--text">•</span> <span class="text-uppercase">{{ rb_pan || "-" }}</span>
                </p>
              </div>
              <v-spacer></v-spacer>
              <v-chip small label color="#E8EFFB" text-color="#0037B7" class="font-weight-medium">
                {{ rb_appStatus || "-" }}
              </v-chip>
            </div>

            <v-divider></v-divider>

            <!-- Branch details as icon tiles -->
            <div class="px-5 py-4">
              <p class="rb-section-title">Branch Details</p>
              <div class="rb-info-grid">
                <div class="rb-info">
                  <div class="rb-ic"><v-icon size="18" color="#0037B7">mdi-source-branch</v-icon></div>
                  <div class="rb-info-text">
                    <span class="rb-info-label">Branch Code</span>
                    <span class="rb-info-value">{{ rb_branchCode || "-" }}</span>
                  </div>
                </div>
                <div class="rb-info">
                  <div class="rb-ic"><v-icon size="18" color="#0037B7">mdi-shield-account-outline</v-icon></div>
                  <div class="rb-info-text">
                    <span class="rb-info-label">Master Code</span>
                    <span class="rb-info-value">{{ rb_masterCode || "-" }}</span>
                  </div>
                </div>
                <div class="rb-info">
                  <div class="rb-ic"><v-icon size="18" color="#0037B7">mdi-account-tie-outline</v-icon></div>
                  <div class="rb-info-text">
                    <span class="rb-info-label">Manager Name</span>
                    <span class="rb-info-value">{{ rb_managerName || "-" }}</span>
                  </div>
                </div>
                <div class="rb-info">
                  <div class="rb-ic"><v-icon size="18" color="#0037B7">mdi-email-outline</v-icon></div>
                  <div class="rb-info-text">
                    <span class="rb-info-label">Manager Mail</span>
                    <span class="rb-info-value">{{ rb_managerMail || "-" }}</span>
                  </div>
                </div>
                <div class="rb-info">
                  <div class="rb-ic"><v-icon size="18" color="#0037B7">mdi-phone-outline</v-icon></div>
                  <div class="rb-info-text">
                    <span class="rb-info-label">Manager Contact</span>
                    <span class="rb-info-value">{{ rb_managerContact || "-" }}</span>
                  </div>
                </div>
              </div>
            </div>

            <v-divider></v-divider>

            <!-- Re-assign target (editable) -->
            <div class="px-5 pt-4 pb-2">
              <p class="rb-section-title">Re-assign To</p>
              <v-row align="center">
                <v-col cols="12" sm="4" md="3">
                  <v-select
                    v-model="sr_clientType"
                    :items="sr_clientTypeItems"
                    color="#0037B7"
                    item-color="#0037B7"
                    dense
                    outlined
                    hide-details
                    class="rounded-lg"
                    label="Client Type"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                    v-model="sr_branch"
                    :items="sr_branchItems"
                    color="#0037B7"
                    item-color="#0037B7"
                    dense
                    outlined
                    hide-details
                    class="rounded-lg"
                    label="Branch Code"
                    :loading="sr_branchLoading"
                  ></v-select>
                </v-col>
              </v-row>
            </div>

            <v-divider></v-divider>

            <!-- Editable plan table (the fetched client's plan) -->
            <v-data-table
              :headers="sr_headers"
              :items="sr_desserts"
              disable-sort
              hide-default-footer
              class="elevation-0 sr-plan-table"
            >
              <template v-slot:item="row">
                <tr>
                  <td>
                    <span class="font-weight-bold black--text sr-seg-name">{{ row.item.sharing_seg.split(' ')[0] }}</span>
                    <small class="grey--text d-block sr-seg-sub">{{ row.item.sharing_seg.split(' ')[1] }}</small>
                  </td>
                  <td>{{ row.item.ap_sharing }}</td>
                  <td>{{ row.item.zebu_sharing }}</td>
                  <td>{{ row.item.min_to_zebu }}</td>
                  <td class="text-right">
                    <v-icon color="#0037B7" @click="srEditItem(row.item, row.item.sharing_seg.split(' '))">
                      mdi-pencil
                    </v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>

          <!-- Actions: re-assign branch for the fetched client -->
          <div v-if="rb_planFetched" class="d-flex flex-wrap align-center mt-4" style="gap: 12px">
            <v-btn
              :disabled="!rb_planFetched || !rb_mobile || !sr_branch || !sr_clientType"
              :loading="rb_updateLoading"
              color="#43A833"
              class="elevation-0 rounded-lg white--text text-none px-6"
              @click="rbUpdateBranch"
            >
              Update Details
            </v-btn>
          </div>
        </div>

        <!-- Pagination Bar -->
        <div class="d-flex flex-column align-center px-4 py-2" v-if="tab !== 3 && (showdata.length || totalPageCount > 1)">
          <v-pagination
            v-model="page"
            :length="totalPageCount"
            :total-visible="9"
            circle
            color="#0037B7"
            :disabled="mainloader"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </v-card>

      <!-- Sharing Ratio Edit Dialog -->
      <v-dialog v-model="sr_dialog" max-width="500px">
        <v-card class="rounded-xl">
          <v-card-title>
            <span class="text-h6 black--text">{{ sr_formTitle }}</span>
            <v-spacer></v-spacer>
            <v-chip v-if="sr_editZebuSharing && (sr_formTitle != 'Options' || sr_optionsType == 1)" label small color="#E8EFFB" text-color="#0037B7">
              AP Sharing: {{ 100 - parseInt(sr_editZebuSharing.toString().split('%')[0]) }}%
            </v-chip>
          </v-card-title>

          <v-card-text style="padding-top: 20px">
            <v-container>
              <v-row v-if="sr_formTitle == 'Options'" no-gutters>
                <v-col cols="12" class="pb-2">
                  <v-btn-toggle v-model="sr_optionsType" mandatory class="sr-options-toggle" background-color="transparent">
                    <v-btn small class="sr-toggle-btn">Lot</v-btn>
                    <v-btn small class="sr-toggle-btn">Percentage</v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col v-if="!(sr_formTitle == 'Options' && sr_optionsType == 0)" cols="6">
                  <v-select
                    v-if="sr_formTitle != 'Options'"
                    v-model="sr_editZebuSharing"
                    :items="srZebuPctItems"
                    label="Zebu Sharing"
                    color="#0037B7"
                    item-color="#0037B7"
                  ></v-select>

                  <v-select
                    v-if="sr_formTitle == 'Options' && sr_optionsType == 1"
                    v-model="sr_editZebuSharing"
                    :items="srZebuPctItems"
                    label="Zebu Sharing"
                    color="#0037B7"
                    item-color="#0037B7"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-if="sr_formTitle != 'Options'"
                    v-model="sr_editMinToZebu"
                    :items="srMinToZebuItems"
                    label="Minimum to Zebu"
                    color="#0037B7"
                    item-color="#0037B7"
                  ></v-select>
                  <v-text-field
                    prefix="Rs. "
                    v-if="sr_formTitle == 'Options'"
                    type="number"
                    :min="5"
                    :max="50"
                    color="#0037B7"
                    :error-messages="Number(sr_editMinToZebu) < 5 ? 'Min Rs. 5' : (Number(sr_editMinToZebu) > 50 ? 'Max Rs. 50' : '')"
                    v-model="sr_editMinToZebu"
                    label="Minimum to Zebu"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0037B7" text class="text-none" @click="srClose">Cancel</v-btn>
            <v-btn
              color="#0037B7"
              text
              class="text-none"
              :disabled="sr_formTitle == 'Options' && (Number(sr_editMinToZebu) < 5 || Number(sr_editMinToZebu) > 50)"
              @click="srSave"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- 3. AP Verification View (Matching EKYC Layout for AP's 7 Stages) -->
    <v-bottom-sheet class="btmsheetclass" v-model="detailDialog" hide-overlay persistent>
      <v-sheet class="text-center" height="100vh" v-if="selectedClient">
        <!-- Top Toolbar -->
        <v-toolbar dense flat>
          <img src="@/assets/Zebu Logo.svg" width="90px" />

          <v-spacer></v-spacer>

          <v-tooltip v-if="selectedClient.app_status === 'rejected' && canRestore && tab === 2" bottom color="#000">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon :loading="switchingStatus" :disabled="switchingStatus" @click="onRestoreApplication">
                <v-icon color="#000">mdi-backup-restore</v-icon>
              </v-btn>
            </template>
            <span>Restore to View stage</span>
          </v-tooltip>

          <v-btn icon :loading="mainloader" @click="downloadFile()">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon :loading="mainloader" :disabled="mainloader" @click="refreshDetailClient()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn icon @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>

        <!-- Tabs Section: AP's 7 Stages -->
        <div class="py-3 px-3">
          <v-row no-gutters style="border-bottom: thin solid #2a2a2a30">
            <!-- Left Tabs (AP's 6 Stages) -->
            <v-col cols="4" class="pa-0">
              <v-tabs v-model="btmltab" show-arrows @change="onLeftTabChange">
                <v-tab class="text-none" :class="getStageClass('mobile')">Mobile</v-tab>
                <v-tab class="text-none" :class="getStageClass('email')">Email</v-tab>
                <v-tab class="text-none" :class="getPairStageClass('pan')">PAN</v-tab>
                <v-tab class="text-none" :class="getStageClass('verification')">Verification</v-tab>
                <v-tab class="text-none" :class="getPairStageClass('bank')">Bank</v-tab>
                <v-tab class="text-none" :class="getPairStageClass('trading')">Trading Preference</v-tab>
                <v-tab class="text-none">Branch</v-tab>
                <v-tabs-slider :color="leftSliderColor"></v-tabs-slider>
              </v-tabs>
            </v-col>

            <!-- Right Tabs (Document Proofs for AP) -->
            <v-col cols="8" class="pa-0">
              <v-tabs v-model="btmrtab" show-arrows @change="onRightTabChange">
                <v-tab class="text-none" :class="getAgreementTabClass()">e-sign document</v-tab>
                <v-tab class="text-none" :class="getAgreementTabClass()">NSE agreement</v-tab>
                <v-tab class="text-none" :class="getAgreementTabClass()">BSE agreement</v-tab>
                <v-tab class="text-none" :class="getAgreementTabClass()">MCX agreement</v-tab>
                <v-tab class="text-none" :class="getPairStageClass('pan_proof')">PAN proof</v-tab>
                <v-tab class="text-none" :class="getStageClass('verification')">Aadhar proof</v-tab>
                <v-tab class="text-none" :class="getPairStageClass('bank_proof')">Bank proof</v-tab>
                <v-tab class="text-none" :class="getPairStageClass('education_proof')">Education proof</v-tab>
                <v-tabs-slider :color="rightSliderColor"></v-tabs-slider>
              </v-tabs>
            </v-col>
          </v-row>

          <!-- Split Screen Row -->
          <v-row no-gutters>
            <!-- Left Pane: Details & Declaration Banners -->
            <v-col cols="4" class="pa-0" style="height: calc(100vh - 140px); overflow: scroll; border-right: thin solid #2a2a2a30">
              <!-- Left Tab Contents (AP 7 Stages) -->
              <div class="pa-3">
                <!-- 0: Mobile (Stage: mobile) -->
                <div v-if="btmltab === 0" class="text-left">
                  <p class="grey--text mb-0">Mobile Number</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.mobileNumber || selectedClient.mobile_no || "-" }}</p>
                  <p class="grey--text mb-0">Mobile verify time</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.mobileVerifyTime || "-" }}</p>
                </div>

                <!-- 1: Email (Stage: email) -->
                <div v-if="btmltab === 1" class="text-left">
                  <p class="grey--text mb-0">Email Address</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.email || selectedClient.client_email || "-" }}</p>
                  <p class="grey--text mb-0">Email verify time</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.EmailVerifyTime || "-" }}</p>
                </div>

                <!-- 2: PAN (Stage: pan) -->
                <div v-if="btmltab === 2" class="text-left">
                  <p class="grey--text mb-0">Name in PAN</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.pan_name || selectedClient.Name || selectedClient.client_name || "-" }}</p>
                  <p class="grey--text mb-0">PAN Number</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.PAN || selectedClient.client_pan || "-" }}</p>
                  <p class="grey--text mb-0">DOB in PAN</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.pan_dob || selectedClient.dob || "-" }}</p>
                  <p class="grey--text mb-0">Aadhaar Number</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.aadhar_no || selectedClient.aadharNo || selectedClient.aadharNumber || "-" }}</p>
                  <p class="grey--text mb-0">PAN Download Response</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.pandownresp || "-" }}</p>
                  <p class="grey--text mb-0">PAN Verify Time</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.panVerifyTime || "-" }}</p>
                </div>

                <!-- 3: Verification (Stage: verification) -->
                <div v-if="btmltab === 3" class="text-left">
                  <p class="grey--text mb-0">Aadhaar Number</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.aadhar_no || selectedClient.aadharNo || "-" }}</p>
                  <p class="grey--text mb-0">Name in Verification</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.adhar_name || selectedClient.Name || "-" }}</p>
                  <p class="grey--text mb-0">DOB in Verification</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.adhar_dob || selectedClient.dob || "-" }}</p>
                  <p class="grey--text mb-0">Gender</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.adhar_gender || selectedClient.gender || "-" }}</p>
                  <p class="grey--text mb-0">Father Name</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.adhar_fathername || selectedClient.fatherName || "-" }}</p>
                  <p class="grey--text mb-0">Address</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.adhar_address || selectedClient.address || "-" }}</p>
                  <p class="grey--text mb-0">District / State / Pincode</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.adhar_dist || selectedClient.district || "" }} {{ selectedClient.adhar_state || selectedClient.state || "" }} - {{ selectedClient.adhar_pincode || selectedClient.pincode || "" }}</p>
                  <p class="grey--text mb-0">Digilocker verify time</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.verification_date_time || "-" }}</p>
                </div>

                <!-- 4: Bank (Stage: bank) -->
                <div v-if="btmltab === 4" class="text-left">
                  <p class="grey--text mb-0">Bank AC No</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.accNo || selectedClient.BankAccountNumber || "-" }}</p>
                  <p class="grey--text mb-0">Bank IFSC Code</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.ifsc || selectedClient.IFSC || "-" }}</p>
                  <p class="grey--text mb-0">Bank MICR Code</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.micr || selectedClient.MICR || "-" }}</p>
                  <p class="grey--text mb-0">Bank Name</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.bankName || selectedClient.BankName || "-" }}</p>
                  <p class="grey--text mb-0">Bank Branch Name</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.branch || selectedClient.BranchName || "-" }}</p>
                  <p class="grey--text mb-0">Bank Address</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.BankAddress || "-" }}</p>
                  <p class="grey--text mb-0">Account Type</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.AddressLine1 || selectedClient.accType || "-" }}</p>
                  <p class="grey--text mb-0">Penny Drop Status</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.peenydropVerify || "-" }}</p>
                  <p class="grey--text mb-0">Penny Drop Verify Time</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.peenydropVerifyTime || "-" }}</p>
                </div>

                <!-- 5: Trading (Stage: trading) -->
                <div v-if="btmltab === 5" class="text-left">
                  <p class="grey--text mb-0">NSE Segments</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.NSEseg || "-" }}</p>
                  <p class="grey--text mb-0">BSE Segments</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.BSEseg || "-" }}</p>
                  <p class="grey--text mb-0">MCX Segments</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.MCXseg || "-" }}</p>
                  <p class="grey--text mb-0">Trading Experience (Years)</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.tradeExpYear || selectedClient.TradingExperience || "-" }}</p>
                  <p class="grey--text mb-0">Qualification</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.qualification || "-" }}</p>
                  <p class="grey--text mb-0">Occupation</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.occupation || "-" }}</p>
                  <p class="grey--text mb-0">Marital Status</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.marital_status || "-" }}</p>
                </div>

                <!-- 6: Branch + Sharing Plan (Stage: branch) -->
                <div v-if="btmltab === 6" class="text-left">
                  <p class="grey--text mb-0">Branch Code</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.zebu_branch_code || "-" }}</p>
                  <p class="grey--text mb-0">Master Code</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.zebu_master_code || "-" }}</p>
                  <p class="grey--text mb-0">Manager Name</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.zebu_manager_name || "-" }}</p>
                  <p class="grey--text mb-0">Manager Mail</p>
                  <p class="black--text font-weight-bold">{{ selectedClient.zebu_manager_mail || "-" }}</p>
                  <p class="grey--text mb-0">Manager Contact</p>
                  <p class="black--text font-weight-bold mb-4">{{ selectedClient.zebu_manager_contact || "-" }}</p>

                  <!-- Sharing Plan -->
                  <p class="grey--text mb-2">Sharing Plan</p>

                  <v-expansion-panels v-if="planGroups.length > 0" accordion multiple class="mb-3 elevation-0 plan-panels">
                    <v-expansion-panel v-for="(grp, gi) in planGroups" :key="gi">
                      <v-expansion-panel-header class="font-weight-bold black--text py-2">
                        {{ grp.title }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="pa-0">
                        <v-simple-table dense class="plan-bordered-table">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left body-2 font-weight-bold black--text px-2">Type</th>
                                <th class="text-center body-2 font-weight-bold black--text px-1">AP %</th>
                                <th class="text-center body-2 font-weight-bold black--text px-1">Zebu %</th>
                                <th class="text-right body-2 font-weight-bold black--text px-2">Min to Zebu</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(r, ri) in grp.rows" :key="ri">
                                <td class="body-2 black--text px-2 py-2">{{ r.label || '-' }}</td>
                                <td class="body-2 text-center black--text px-1 py-2">{{ r.ap_sharing || '-' }}</td>
                                <td class="body-2 text-center black--text px-1 py-2">{{ r.zebu_sharing || '-' }}</td>
                                <td class="body-2 text-right black--text px-2 py-2">{{ r.min_to_zebu || '-' }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <div v-else class="mb-3">
                    <p class="caption grey--text mb-1">No formatted plan data found.</p>
                    <div v-if="parsedPlanInfo.raw" class="caption grey--text text--darken-1 word-break-all bg-light pa-2 rounded" style="word-break: break-all">
                      Raw Plan: {{ parsedPlanInfo.raw }}
                    </div>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Right Pane: PDF / Document Viewers using file?path= -->
            <v-col cols="8" style="height: calc(100vh - 140px); overflow: scroll" class="pa-0">
              <v-tabs-items v-model="btmrtab">
                <!-- 0: e-sign document -->
                <v-tab-item>
                  <iframe
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.affiliate_pdf_loc || selectedClient.e_signed_pdf_path)"
                    width="100%"
                  ></iframe>
                </v-tab-item>

                <!-- 1: NSE agreement -->
                <v-tab-item>
                  <iframe
                    v-if="selectedClient.nse_agreement_loc"
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.nse_agreement_loc)"
                    width="100%"
                  ></iframe>
                  <div v-else class="pa-6 text-center grey--text" style="height: calc(100vh - 160px)">
                    No NSE agreement available.
                  </div>
                </v-tab-item>

                <!-- 2: BSE agreement -->
                <v-tab-item>
                  <iframe
                    v-if="selectedClient.bse_agreement_loc"
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.bse_agreement_loc)"
                    width="100%"
                  ></iframe>
                  <div v-else class="pa-6 text-center grey--text" style="height: calc(100vh - 160px)">
                    No BSE agreement available.
                  </div>
                </v-tab-item>

                <!-- 3: MCX agreement -->
                <v-tab-item>
                  <iframe
                    v-if="selectedClient.mcx_agreement_loc"
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.mcx_agreement_loc)"
                    width="100%"
                  ></iframe>
                  <div v-else class="pa-6 text-center grey--text" style="height: calc(100vh - 160px)">
                    No MCX agreement available.
                  </div>
                </v-tab-item>

                <!-- 4: PAN proof -->
                <v-tab-item style="position: relative">
                  <iframe
                    v-if="isPdf(selectedClient.uploadPAN || selectedClient.panpdfloc || selectedClient.panimgloc)"
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.uploadPAN || selectedClient.panpdfloc || selectedClient.panimgloc)"
                    width="100%"
                  ></iframe>
                  <div v-else>
                    <img
                      :style="getImageStyle(panrot)"
                      :src="getFileUrl(selectedClient.uploadPAN || selectedClient.panimgloc || selectedClient.panpdfloc)"
                      :width="getImageWidth(panrot)"
                      alt="PAN Proof"
                    />
                    <div style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="rotateImg(panrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomOutImg(panrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomInImg(panrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="flipImg(panrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-left-variant</v-icon></v-btn>
                      <v-btn class="mt-2" @click="resetImg(panrot)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                </v-tab-item>

                <!-- 2: Aadhar proof -->
                <v-tab-item style="position: relative">
                  <iframe
                    v-if="isPdf(selectedClient.uploadAadhar || selectedClient.adhar_file || selectedClient.adhar_image || selectedClient.adharimg)"
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.uploadAadhar || selectedClient.adhar_file || selectedClient.adhar_image || selectedClient.adharimg)"
                    width="100%"
                  ></iframe>
                  <div v-else>
                    <img
                      :style="getImageStyle(adharrot)"
                      :src="getFileUrl(selectedClient.uploadAadhar || selectedClient.adhar_image || selectedClient.adharimg || selectedClient.adhar_file)"
                      :width="getImageWidth(adharrot)"
                      alt="Aadhaar Proof"
                    />
                    <div style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="rotateImg(adharrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomOutImg(adharrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomInImg(adharrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="flipImg(adharrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-left-variant</v-icon></v-btn>
                      <v-btn class="mt-2" @click="resetImg(adharrot)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                </v-tab-item>

                <!-- 3: Bank proof -->
                <v-tab-item style="position: relative">
                  <iframe
                    v-if="isPdf(selectedClient.uploadBank || selectedClient.bankFileLoc)"
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.uploadBank || selectedClient.bankFileLoc)"
                    width="100%"
                  ></iframe>
                  <div v-else>
                    <img
                      :style="getImageStyle(bankrot)"
                      :src="getFileUrl(selectedClient.uploadBank || selectedClient.bankFileLoc)"
                      :width="getImageWidth(bankrot)"
                      alt="Bank Proof"
                    />
                    <div style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="rotateImg(bankrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomOutImg(bankrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomInImg(bankrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="flipImg(bankrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-left-variant</v-icon></v-btn>
                      <v-btn class="mt-2" @click="resetImg(bankrot)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                </v-tab-item>

                <!-- 4: Education proof -->
                <v-tab-item style="position: relative">
                  <iframe
                    v-if="isPdf(selectedClient.uploadFinancialproof || selectedClient.edufileloc)"
                    style="border: none; border-radius: 0; height: calc(100vh - 160px)"
                    :src="getFileUrl(selectedClient.uploadFinancialproof || selectedClient.edufileloc)"
                    width="100%"
                  ></iframe>
                  <div v-else>
                    <img
                      :style="getImageStyle(incrot)"
                      :src="getFileUrl(selectedClient.uploadFinancialproof || selectedClient.edufileloc)"
                      :width="getImageWidth(incrot)"
                      alt="Education Proof"
                    />
                    <div style="position: fixed !important; top: 112px; right: 8px; display: grid !important">
                      <v-btn @click="rotateImg(incrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-right</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomOutImg(incrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-minus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="zoomInImg(incrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-plus</v-icon></v-btn>
                      <v-btn class="mt-2" @click="flipImg(incrot)" fab small color="#2a2a2a"><v-icon color="#fff">mdi-rotate-left-variant</v-icon></v-btn>
                      <v-btn class="mt-2" @click="resetImg(incrot)" fab small color="#fff"><v-icon color="#000">mdi-close</v-icon></v-btn>
                    </div>
                  </div>
                </v-tab-item>

              </v-tabs-items>
            </v-col>
          </v-row>
        </div>

        <!-- Fixed Bottom Footer Bar -->
        <v-footer style="position: absolute; width: 100%; bottom: 0; overflow: hidden !important">
          <v-row>
            <!-- Left side (Stage Status Banner / Actions for Current AP Stage) -->
            <v-col style="border-right: 1px solid #ddd !important" cols="4" :class="activeGroupStatus ? 'pa-0' : 'pa-3'">
              <div v-if="currentStageKey === 'branch'" class="py-3 text-center">
                <span class="font-weight-bold text-subtitle-1 black--text">Branch Details</span>
              </div>
              <v-card v-else-if="activeGroupStatus === 'yes' || activeGroupStatus === 'no'" width="100%" :color="activeGroupStatus === 'yes' ? '#43A833' : '#FF1717'" class="text-center pt-5 pb-3 elevation-0 rounded-0 white--text font-weight-medium">
                <v-icon color="white" size="28" class="mr-3">{{ activeGroupStatus === 'yes' ? 'mdi-checkbox-multiple-marked-circle-outline' : 'mdi-close-circle-outline' }}</v-icon>
                <span>{{ currentStageLabel }} stage, as {{ activeGroupStatus === 'yes' ? 'Approved' : 'Rejected' }}</span>

                <v-tooltip v-if="currentStageKey !== 'mobile' && currentStageKey !== 'email' && !appFinalized" top color="#000">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="float-right mr-3 mt-n2" small fab @click="resetCurrentStage">
                      <v-icon color="#000">mdi-backup-restore</v-icon>
                    </v-btn>
                  </template>
                  <span>Restore this stage</span>
                </v-tooltip>
              </v-card>

              <v-row v-else-if="canTakeAction && currentStageKey" no-gutters>
                <v-col cols="6" class="pr-1">
                  <v-btn @click="promptRejectStage(currentStageKey)" height="40px" block color="#DDD" class="elevation-0 rounded-lg">
                    <span class="black--text text-none">Reject</span>
                  </v-btn>
                </v-col>
                <v-col cols="6" class="pl-1">
                  <v-btn @click="onApproveStage(currentStageKey)" height="40px" block :loading="updatingStageKey === currentStageKey && updatingStageVal === 'yes'" color="#FB8C00" class="elevation-0 rounded-lg">
                    <span class="white--text text-none">Approve</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <!-- Right side (App status & Final Approve/Decline) -->
            <v-col class="px-0 py-2" cols="8">
              <v-toolbar dense flat color="transparent">
                <p class="grey--text mb-0 text-left">
                  App status :
                  <span class="black--text font-weight-bold">{{ selectedClient.app_status && selectedClient.app_status !== 'file' ? selectedClient.app_status : '-' }}</span>
                  <span v-if="currentStageReason && tab === 2" class="ml-4">
                    reason : <span class="black--text font-weight-bold">{{ currentStageReason }}</span>
                  </span>
                </p>

                <v-spacer></v-spacer>

                <template v-if="canTakeAction">
                  <v-btn
                    @click="promptRejectApplication"
                    :disabled="selectedClient.app_status === 'rejected'"
                    color="#FF1717"
                    class="elevation-0 rounded-lg mr-4"
                  >
                    <span class="white--text text-none">Decline</span>
                  </v-btn>
                  <v-btn
                    @click="onApproveApplication"
                    :disabled="selectedClient.app_status === 'approved'"
                    :loading="updatingStatus"
                    color="#43A833"
                    class="elevation-0 rounded-lg"
                  >
                    <span class="white--text text-none">Approve</span>
                  </v-btn>
                </template>
              </v-toolbar>
            </v-col>
          </v-row>
        </v-footer>
      </v-sheet>
    </v-bottom-sheet>

    <!-- Stage Reject Reason Dialog -->
    <v-dialog v-model="stageRejectDialog" persistent max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Enter the stage rejection reason</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="updatingStageKey !== ''" icon @click="stageRejectDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-4 pb-4 pt-2 text-left">
          <p class="font-weight-bold mb-1">* {{ getStageLabel(activeStageKey) }} stage</p>
          <v-row v-if="rejectStageOptions.length > 1" no-gutters>
            <v-col v-for="opt in rejectStageOptions" :key="opt.key" cols="6">
              <v-checkbox
                v-model="selectedRejectStages"
                :value="opt.key"
                :label="opt.label"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-text-field
            v-model="stageRejectReason"
            label="Reject reason"
            outlined
            clearable
            class="rounded-lg mt-3"
            hide-details="auto"
            :error-messages="stageRejectError"
          ></v-text-field>
          <v-btn
            :loading="updatingStageKey !== ''"
            :disabled="!stageRejectReason || !stageRejectReason.trim() || selectedRejectStages.length === 0"
            @click="submitStageReject"
            block
            large
            color="#FF1717"
            class="elevation-0 rounded-lg mt-4 mb-1"
          >
            <span class="white--text text-none">Reject this <b>{{ getStageLabel(activeStageKey) }}</b> stage</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Application Final Reject Reason Dialog -->
    <v-dialog v-model="appRejectDialog" persistent max-width="400">
      <v-card class="rounded-xl">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold red--text">Reject Whole Application</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="updatingStatus" icon @click="appRejectDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-4 pb-4 pt-2 text-left">
          <div class="caption grey--text text--darken-2 mb-2">
            Enter reason for rejecting this application (required):
          </div>
          <v-text-field
            color="#fb8c00"
            v-model="appRejectReason"
            label="Application Rejection Reason"
            outlined
            class="rounded-lg mt-2"
            hide-details="auto"
            :error-messages="appRejectError"
          ></v-text-field>
          <v-btn
            :loading="updatingStatus"
            @click="submitApplicationReject"
            block
            large
            color="#FF1717"
            class="elevation-0 rounded-lg mt-4"
          >
            <span class="white--text text-none">Confirm Application Reject</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card class="rounded-xl" v-if="deleteTarget">
        <v-toolbar dense flat>
          <p class="mb-0 font-weight-bold">Enter the deletion reason</p>
          <v-spacer></v-spacer>
          <v-btn :disabled="deleteBtnLoading" icon @click="deleteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-4 pb-4 pt-2 text-left">
          <p class="mb-3">
            Are you sure you want to delete
            <b>{{ deleteTarget.Name || deleteTarget.client_name || deleteTarget.pan_name || deleteTarget.mobileNumber || deleteTarget.mobile_no }}</b>
            application ?
          </p>
          <v-text-field
            v-model="deleteReason"
            label="Delete reason"
            outlined
            clearable
            class="rounded-lg"
            hide-details="auto"
            :error-messages="deleteError"
          ></v-text-field>
          <v-row no-gutters class="mt-4">
            <v-col cols="6" class="pr-1">
              <v-btn @click="deleteDialog = false" :disabled="deleteBtnLoading" block large color="#eeeeee" class="elevation-0 rounded-lg">
                <span class="text-none">No</span>
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-1">
              <v-btn @click="confirmDelete" :loading="deleteBtnLoading" :disabled="!deleteReason || !deleteReason.trim()" block large color="#FF1717" class="elevation-0 rounded-lg">
                <span class="white--text text-none">Yes</span>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import LayOut from "../components/LayOut.vue";
import { apApiBase } from "../api";

function getOperatorLog() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const datetime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  const emp_ID = localStorage.getItem("empcode") || "E123";
  const emp_emailid = localStorage.getItem("email") || "ops@zebu.com";

  return { emp_ID, emp_emailid, datetime };
}

async function fetchCounts() {
  try {
    const response = await axios.get(`${apApiBase}/dashboard/counts`);
    return response.data;
  } catch (error) {
    const errData = error.response ? error.response.data : {};
    throw new Error(errData.msg || errData.error || error.message || "Failed to fetch counts");
  }
}

async function fetchClientData(mobileNo) {
  try {
    const response = await axios.get(`${apApiBase}/client_data`, {
      params: { mobile_no: mobileNo },
    });
    return response.data;
  } catch (error) {
    const errData = error.response ? error.response.data : {};
    throw new Error(errData.msg || errData.error || error.message || "Failed to fetch client data");
  }
}

async function fetchDashboardGrid({ filter = "view", limit = 100, page = 1, from = "", to = "", search_term = "", app_status = [], stage = [] }) {
  try {
    const params = new URLSearchParams();
    if (filter) params.append("filter", filter);
    if (limit) params.append("limit", limit);
    if (page) params.append("offset", page);

    const body = {};
    if (from) body.from = from;
    if (to) body.to = to;
    if (search_term) body.search_term = search_term;
    if (Array.isArray(app_status) && app_status.length) body.app_status = app_status;
    if (Array.isArray(stage) && stage.length) body.stage = stage;

    const response = await axios.post(`${apApiBase}/dashboard?${params.toString()}`, body);
    return response.data;
  } catch (error) {
    const errData = error.response ? error.response.data : {};
    throw new Error(errData.msg || errData.error || error.message || "Failed to fetch dashboard data");
  }
}

async function updateStageApproval({ mobileNo, stage, value, reason = "" }) {
  try {
    const log = getOperatorLog();
    const payload = { mobileNo, stage, value, reason, log };
    const response = await axios.post(`${apApiBase}/stage_update`, payload);
    return response.data;
  } catch (error) {
    const errData = error.response ? error.response.data : {};
    const errObj = new Error(errData.msg || errData.error || error.message || "Failed to update stage");
    errObj.responseData = errData;
    throw errObj;
  }
}

async function switchApplicationStatus({ mobileNo, stages }) {
  try {
    const log = getOperatorLog();
    const payload = { mobile_no: mobileNo, stages, log };
    const response = await axios.post(`${apApiBase}/status_switch`, payload);
    return response.data;
  } catch (error) {
    const errData = error.response ? error.response.data : {};
    const errObj = new Error(errData.msg || errData.error || error.message || "Failed to switch application status");
    errObj.responseData = errData;
    throw errObj;
  }
}

async function updateApplicationStatus({ mobileNo, status, rejected_reason = "" }) {
  try {
    const log = getOperatorLog();
    const payload = { mobileNo, status, log };
    if (status === "rejected" && rejected_reason) {
      payload.rejected_reason = rejected_reason;
    }
    const response = await axios.post(`${apApiBase}/status_update`, payload);
    return response.data;
  } catch (error) {
    const errData = error.response ? error.response.data : {};
    const errObj = new Error(errData.msg || errData.error || error.message || "Failed to update application status");
    errObj.responseData = errData;
    throw errObj;
  }
}

async function deleteClient({ mobileNo, reason = "" }) {
  try {
    const log = { ...getOperatorLog(), type: "delete", reason };
    const payload = { mobile: mobileNo, log };
    const response = await axios.post(`${apApiBase}/deletebtn`, payload);
    return response.data;
  } catch (error) {
    const errData = error.response ? error.response.data : {};
    const errObj = new Error(errData.msg || errData.error || error.message || "Failed to delete application");
    errObj.status = error.response ? error.response.status : 0;
    errObj.responseData = errData;
    throw errObj;
  }
}

export default {
  name: "ApDashboard",
  components: {
    LayOut,
  },
  data() {
    return {
      // Theme Snackbar
      snackbar: false,
      snackmsgbar: "",
      snackbarclr: "default",

      // Counts
      counts: {
        total: 0,
        view: 0,
        e_signed_pending: 0,
        e_signed_completed: 0,
        re_e_signed_pending: 0,
        re_e_signed_completed: 0,
        completed: 0,
        rejected: 0,
      },

      // Tabs & Filters
      tab: 0,
      tabFilters: ["view", "completed", "rejected"],
      search: "",
      statusFilter: [],
      stageFilter: [],
      stageFilterOptions: [
        "mobile",
        "email",
        "pan",
        "digilocker",
        "pan_proof",
        "bank",
        "bank_proof",
        "segment",
        "education_proof",
        "submit",
        "complete",
      ],
      alldate: "",
      dateSelect1: "",
      dateSelect2: "",
      dateMenu: false,

      // Detail Tabs (0 to 6 for AP's 7 stages)
      btmltab: 0,
      btmrtab: 0,

      // Image Rotation Controls
      panrot: { rot: 0, flip: 1, pad: 0 },
      adharrot: { rot: 0, flip: 1, pad: 0 },
      bankrot: { rot: 0, flip: 1, pad: 0 },
      incrot: { rot: 0, flip: 1, pad: 0 },
      sigrot: { rot: 0, flip: 1, pad: 0 },

      // Grid data
      showdata: [],
      totalRecords: 0,
      totalPageCount: 1,
      page: 1,
      pageSize: 100,
      mainloader: false,

      // Headers
      headers: [
        { text: "S.No", value: "sno", sortable: false, width: "60px" },
        { text: "Initiated Date", value: "date_time", sortable: false },
        { text: "Mobile", value: "mobile_no", sortable: false },
        { text: "Client Id", value: "client_id", sortable: false },
        // { text: "regMemberName", value: "regMemberName", sortable: false },
        { text: "Name", value: "client_name", sortable: false },
        { text: "PAN", value: "client_pan", sortable: false },
        { text: "Status", value: "app_status", sortable: false },
        { text: "e-signed date", value: "esigned_datetime", sortable: false },
        { text: "Actions", value: "view", sortable: false, align: "center" },
      ],

      // Exact Stages / Proofs in AP
      stageDefs: [
        { key: "mobile", label: "Mobile" },
        { key: "email", label: "Email" },
        { key: "pan", label: "PAN Details" },
        { key: "pan_proof", label: "PAN Proof" },
        { key: "verification", label: "Verification" },
        { key: "bank", label: "Bank Details" },
        { key: "bank_proof", label: "Bank Proof" },
        { key: "trading", label: "Trading Preferences" },
        { key: "education_proof", label: "Education Proof" },
        { key: "plan", label: "Plan" },
        { key: "branch", label: "Branch" },
      ],

      // Detail Modal state
      detailDialog: false,
      selectedClient: null,
      pendingStagesAlert: [],
      lastActiveSide: "left",

      // Stage Reject Dialog
      stageRejectDialog: false,
      activeStageKey: "",
      stageRejectReason: "",
      stageRejectError: "",
      rejectStageOptions: [],
      selectedRejectStages: [],
      updatingStageKey: "",
      updatingStageVal: "",

      // Application Reject Dialog
      appRejectDialog: false,
      appRejectReason: "",
      appRejectError: "",
      updatingStatus: false,
      switchingStatus: false,
      // emp codes allowed to restore a rejected application (status_switch)
      restoreAllowedEmps: ["ZE785","ZE806"],

      // Delete Confirmation Dialog
      deleteDialog: false,
      deleteTarget: null,
      deleteReason: "",
      deleteError: "",
      deleteBtnLoading: false,

      // Sharing Ratio tab (adapted from ShareGen)
      sr_branchItems: [],
      sr_branchLoading: false,
      sr_branch: null,
      sr_clientType: "AP",
      sr_clientTypeItems: ["AP"],
      sr_dialog: false,
      sr_formTitle: null,
      sr_editZebuSharing: null,
      sr_editApSharing: null,
      sr_editMinToZebu: null,
      sr_optionsType: 0,
      sr_editedIndex: -1,
      sr_headers: [
        { text: "Sharing Segment", align: "start", sortable: false, value: "sharing_seg" },
        { text: "AP/RA Sharing", value: "ap_sharing" },
        { text: "Zebu Sharing", value: "zebu_sharing" },
        { text: "Min to Zebu", value: "min_to_zebu" },
        { text: "Actions", value: "actions", sortable: false, align: "end" },
      ],
      sr_desserts: [],

      // Re-assign Branch (getPlan / updateBranch) — shares the editable plan table
      rb_mobile: "",
      rb_status: "pending",
      rb_statusItems: [
        { text: "Complete", value: "complete" },
        { text: "Pending", value: "pending" },
        { text: "Approved", value: "approved" },
        { text: "Rejected", value: "rejected" },
      ],
      rb_planFetched: false,
      rb_fetchLoading: false,
      rb_updateLoading: false,
      // extra client details returned by getPlan
      rb_pan: "",
      rb_panName: "",
      rb_clientId: "",
      rb_appStatus: "",
      // branch details returned by getPlan
      rb_branchCode: "",
      rb_masterCode: "",
      rb_managerName: "",
      rb_managerMail: "",
      rb_managerContact: "",
    };
  },
  computed: {
    filteredHeaders() {
      if (this.tab === 1) { // Complete tab
        return [
          { text: "Completed Date", value: "approved_datetime", sortable: true },
          { text: "Actions", value: "view", sortable: false, align: "center" },
          { text: "Mobile", value: "mobile_no", sortable: false },
          { text: "Client Id", value: "client_id", sortable: false },
          // { text: "regMemberName", value: "regMemberName", sortable: false },
          { text: "Name", value: "client_name", sortable: false },
          { text: "PAN", value: "client_pan", sortable: false },
          { text: "e-signed date", value: "esigned_datetime", sortable: false },
          { text: "Initiated Date", value: "date_time", sortable: false },
        ];
      } else if (this.tab === 2) { // Reject tab
        return [
          { text: "Rejected Date", value: "rejection_date_time", sortable: true },
          { text: "Actions", value: "view", sortable: false, align: "center" },
          { text: "Mobile", value: "mobile_no", sortable: false },
          { text: "Client Id", value: "client_id", sortable: false },
          // { text: "regMemberName", value: "regMemberName", sortable: false },
          { text: "Name", value: "client_name", sortable: false },
          { text: "PAN", value: "client_pan", sortable: false },
          { text: "Status", value: "app_status", sortable: false },
          { text: "e-signed date", value: "esigned_datetime", sortable: false },
          { text: "Initiated Date", value: "date_time", sortable: false },
          { text: "Delete", value: "del", sortable: false, align: "center" },
        ];
      } else { // View tab (tab === 0)
        const grouped = this.statusFilter.length || this.stageFilter.length;
        return [
          { text: "Initiated Date", value: "date_time", sortable: true },
          { text: "Actions", value: "view", sortable: false, align: "center" },
          { text: "Mobile", value: "mobile_no", sortable: false },
          { text: "Client Id", value: "client_id", sortable: false },
          // { text: "regMemberName", value: "regMemberName", sortable: false },
          { text: "Name", value: "client_name", sortable: false },
          { text: "PAN", value: "client_pan", sortable: false },
          // Status is redundant when rows are grouped by status
          ...(grouped ? [] : [{ text: "Status", value: "app_status", sortable: false }]),
          { text: "e-signed date", value: "esigned_datetime", sortable: false },
          { text: "Delete", value: "del", sortable: false, align: "center" },
        ];
      }
    },
    // View tab badge: when the View tab is filtered (status/stage), show the
    // filtered result count so the badge matches the grid; otherwise the full view count.
    viewTabCount() {
      if (this.tab === 0 && (this.statusFilter.length || this.stageFilter.length)) {
        return this.totalRecords || 0;
      }
      return this.counts.view || 0;
    },
    // Column the current tab is sorted by (descending) — matches EKYC
    sortByField() {
      if (this.tab === 1) return "approved_datetime";
      if (this.tab === 2) return "rejection_date_time";
      return "date_time";
    },
    // Group the View tab by status when a status/stage filter is active (like EKYC)
    groupByField() {
      if (this.tab === 0 && (this.statusFilter.length || this.stageFilter.length)) {
        return "groupStatus";
      }
      return [];
    },
    appRejected() {
      const s = this.selectedClient && this.selectedClient.app_status ? String(this.selectedClient.app_status).trim().toLowerCase() : "";
      return s === "rejected";
    },
    appFinalized() {
      const s = this.selectedClient && this.selectedClient.app_status ? String(this.selectedClient.app_status).trim().toLowerCase() : "";
      return s === "approved" || s === "rejected";
    },
    // Underline (slider) color for the left tab group, based on the active left tab
    leftSliderColor() {
      const leftMap = ["mobile", "email", "pan", "verification", "bank", "trading", "branch"];
      const key = leftMap[this.btmltab] || "";
      if (key === "branch") return "";
      return this.groupStatusColor(key);
    },
    // Underline (slider) color for the right tab group, based on the active right tab
    rightSliderColor() {
      // e-sign(0), NSE(1), BSE(2), MCX(3) -> red only when the application is rejected
      if (this.btmrtab <= 3) {
        return this.appRejected ? "#FF1717" : "";
      }
      const rightMap = ["mobile", "", "", "", "pan_proof", "verification", "bank_proof", "education_proof"];
      return this.groupStatusColor(rightMap[this.btmrtab] || "");
    },
    // Only whitelisted emp codes may restore a rejected application
    canRestore() {
      const emp = localStorage.getItem("empcode") || "";
      return this.restoreAllowedEmps.includes(emp);
    },
    // Reject/Approve/Decline/Approve action buttons are only allowed once
    // the application has reached an e-signed / re-e-signed completed state.
    canTakeAction() {
      const s = this.selectedClient && this.selectedClient.app_status ? String(this.selectedClient.app_status).trim().toLowerCase() : "";
      return s === "e-signed completed" || s === "re-e-signed completed";
    },
    statusOptions() {
      // app_status values available to filter, per active tab
      if (this.tab === 1) return ["approved"]; // Complete
      if (this.tab === 2) return ["rejected"]; // Reject
      // View tab
      return [
        "e-signed pending",
        "re-e-signed pending",
        "e-signed completed",
        "re-e-signed completed",
      ];
    },
    itemsWithSno() {
      return this.showdata.map((item, index) => ({
        ...item,
        sno: (this.page - 1) * this.pageSize + index + 1,
        // normalize the date fields so display and sorting use the same value
        date_time: item.mobileVerifyTime || item.date_time || item.datetime || "",
        approved_datetime: item.approved_datetime || item.approved_date_time || item.esigned_datetime || "",
        rejection_date_time: item.rejection_date_time || item.rejection_datetime || "",
        esigned_datetime: item.esigned_datetime || "",
        // group value: app_status, falling back to the current stage (changes)
        groupStatus: item.app_status || item.changes || "-",
      }));
    },
    currentStageKey() {
      if (this.lastActiveSide === "right") {
        const rightMap = ["mobile", "", "", "", "pan_proof", "verification", "bank_proof", "education_proof"];
        return rightMap[this.btmrtab] || "";
      } else {
        const leftMap = ["mobile", "email", "pan", "verification", "bank", "trading", "branch"];
        return leftMap[this.btmltab] || "";
      }
    },
    currentStageLabel() {
      if (!this.currentStageKey) return "Stage";
      return this.getStageLabel(this.currentStageKey);
    },
    activeStageStatus() {
      if (!this.currentStageKey) return "";
      return this.getStageValue(this.currentStageKey);
    },
    // Group-aware status: for paired stages (pan/pan_proof, bank/bank_proof,
    // trading/education_proof) treat the stage as rejected if EITHER is "no",
    // so the Reject/Approve buttons are hidden and the rejected banner shows.
    activeGroupStatus() {
      if (!this.currentStageKey) return "";
      const group = this.getStageGroup(this.currentStageKey);
      const vals = group.map((k) => this.getStageValue(k));
      if (vals.includes("no")) return "no";
      if (this.getStageValue(this.currentStageKey) === "yes") return "yes";
      return "";
    },
    currentStageReason() {
      if (!this.selectedClient) return "";
      const key = this.currentStageKey;
      if (key) {
        const stageVal = this.getStageValue(key);
        if (stageVal === "no") {
          const reasonMap = {
            mobile: "mobile_reject_reason",
            email: "email_reject_reason",
            pan: "PAN_reject_reason",
            pan_proof: "pan_proof_rejection_reason",
            verification: "verification_reject_reason",
            bank: "bank_reject_reason",
            bank_proof: "bank_proof_reject_reason",
            trading: "trade_preference_reject_reason",
            education_proof: "education_proof_rejection_reason",
          };
          const field = reasonMap[key];
          if (field && this.selectedClient[field]) {
            return this.selectedClient[field];
          }
        }
      }
      return this.selectedClient.rejected_reason || "";
    },

    planGroups() {
      return this.buildPlanGroups(this.parsedPlanInfo.list || []);
    },

    // Initials for the fetched client's avatar (from PAN name)
    rbInitials() {
      const n = String(this.rb_panName || "").trim();
      if (!n) return "-";
      const parts = n.split(/\s+/);
      return (parts[0].charAt(0) + (parts[1] ? parts[1].charAt(0) : "")).toUpperCase();
    },

    // Zebu Sharing (%) options — always include the row's current value so the
    // edit dialog pre-fills with whatever getPlan returned.
    srZebuPctItems() {
      const base = ["15%", "20%", "25%", "30%", "35%", "40%", "50%", "60%", "70%", "80%", "90%"];
      const v = this.sr_editZebuSharing;
      return v && String(v).includes("%") && !base.includes(v) ? [v, ...base] : base;
    },

    // Min to Zebu options (per segment) — likewise include the current value.
    srMinToZebuItems() {
      const base =
        this.sr_formTitle === "Equities Delivery"
          ? ["1500/cr", "2000/cr", "2500/cr", "3000/cr", "4000/cr", "5000/cr"]
          : ["150/cr", "200/cr", "250/cr", "300/cr", "400/cr", "500/cr"];
      const v = this.sr_editMinToZebu;
      return v && !base.includes(v) ? [v, ...base] : base;
    },

    parsedPlanInfo() {
      if (!this.selectedClient) return { list: [], branch: "", member: "", raw: "" };
      const rawPlan =
        this.selectedClient.plan ||
        this.selectedClient.Plan ||
        this.selectedClient.client_plan ||
        this.selectedClient.sharingPlan;
      return this.decodePlanString(rawPlan);
    },
  },
  created() {
    document.title = "AP-dashboard";
    // Default date range (like EKYC): from 2 months ago to tomorrow
    const now = new Date();
    this.dateSelect1 = new Date(now.getFullYear(), now.getMonth() - 2, now.getDate()).toISOString().slice(0, 10);
    this.dateSelect2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).toISOString().slice(0, 10);
    this.formatAllDate();
    // View tab defaults to the two completed statuses selected (like EKYC)
    this.statusFilter = this.defaultStatusFilter();
    this.refreshAll();
    // Seed the Sharing Ratio table with the default plan
    this.srInitialize();
  },
  watch: {
    sr_dialog(val) {
      if (!val) this.srClose();
    },
    sr_optionsType(val) {
      if (this.sr_formTitle == "Options") {
        this.sr_editZebuSharing = val == 1 ? "30%" : "-";
        this.sr_editApSharing = val == 1 ? null : "-";
      }
    },
  },
  methods: {
    showToast(msg, clr = "success") {
      this.snackmsgbar = msg;
      this.snackbarclr = clr;
      this.snackbar = true;
    },

    async refreshAll() {
      if (this.detailDialog && this.selectedClient) {
        await this.refreshDetailClient();
      } else {
        await this.loadGrid(this.page);
      }
    },

    async loadCounts() {
      try {
        const res = await fetchCounts();
        this.counts = {
          total: res.total || 0,
          view: res.view || 0,
          e_signed_pending: res.e_signed_pending || 0,
          e_signed_completed: res.e_signed_completed || 0,
          re_e_signed_pending: res.re_e_signed_pending || 0,
          re_e_signed_completed: res.re_e_signed_completed || 0,
          completed: res.completed || 0,
          rejected: res.rejected || 0,
        };
      } catch (err) {
        console.error("Failed to load counts:", err);
      }
    },

    async loadGrid(pageNum = 1) {
      this.page = pageNum;
      this.mainloader = true;
      const currentFilter = this.tabFilters[this.tab] || "view";

      try {
        const res = await fetchDashboardGrid({
          filter: currentFilter,
          limit: this.pageSize,
          page: this.page,
          from: this.dateSelect1,
          to: this.dateSelect2,
          search_term: (this.search || "").trim().length > 2 ? this.search.trim() : "",
          app_status: this.statusFilter,
          stage: this.stageFilter,
        });

        this.showdata = res.data || [];
        this.totalRecords = res.total || 0;
        this.totalPageCount = res.total_page_count || 1;

        if (res.counts) {
          this.counts = {
            total: res.counts.total || 0,
            view: res.counts.view || 0,
            e_signed_pending: res.counts.e_signed_pending || 0,
            e_signed_completed: res.counts.e_signed_completed || 0,
            re_e_signed_pending: res.counts.re_e_signed_pending || 0,
            re_e_signed_completed: res.counts.re_e_signed_completed || 0,
            completed: res.counts.completed || 0,
            rejected: res.counts.rejected || 0,
          };
        } else {
          this.loadCounts();
        }

        if (this.selectedClient) {
          const clientMobile = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;
          const updated = this.showdata.find(
            (item) => (item.mobileNumber || item.mobile_no) === clientMobile
          );
          if (updated) {
            // merge so the detailed client_data fields are preserved
            this.selectedClient = { ...this.selectedClient, ...updated };
          }
        }
      } catch (err) {
        console.error("Failed to load dashboard data:", err);
        this.showToast(err.message || "Error fetching dashboard data", "error");
      } finally {
        this.mainloader = false;
      }
    },

    // View tab keeps the two "completed" statuses selected by default (like EKYC)
    defaultStatusFilter() {
      return this.tab === 0 ? ["e-signed completed", "re-e-signed completed"] : [];
    },

    onTabChange() {
      // Sharing Ratio tab has no grid; lazy-load the branch codes on first open
      if (this.tab === 3) {
        if (!this.sr_branchItems.length) this.srLoadBranchCodes();
        return;
      }
      // status options differ per tab, so reset to that tab's default selection
      this.statusFilter = this.defaultStatusFilter();
      this.stageFilter = [];
      this.loadGrid(1);
    },

    onStatusChange() {
      this.loadGrid(1);
    },

    removeStatusGroup(group) {
      this.statusFilter = this.statusFilter.filter((s) => s !== group);
      this.onStatusChange();
    },

    onStageChange() {
      this.loadGrid(1);
    },

    onSearch() {
      // same as EKYC searchapicall: api only for 3+ chars, reload when emptied, 1-2 chars are filtered by the table
      const len = (this.search || "").trim().length;
      if (len > 0 && len < 3) return;
      this.showdata = []; // EKYC clears the rows and shows the table loader while searching
      this.loadGrid(1);
    },

    formatAllDate() {
      // Match EKYC/ReKYC display format e.g. "Jun 03 ~ Aug 04 2026"
      if (this.dateSelect1 && this.dateSelect2) {
        const dfrom = new Date(this.dateSelect1).toDateString().slice(3);
        const dto = new Date(this.dateSelect2).toDateString().slice(3);
        this.alldate = `${dfrom.slice(0, 7)} ~ ${dto.slice(0, 12)}`;
      } else if (this.dateSelect1) {
        this.alldate = new Date(this.dateSelect1).toDateString().slice(3, 11);
      } else {
        this.alldate = "";
      }
    },

    onDatePickDone() {
      this.dateMenu = false;
      this.formatAllDate();
      this.loadGrid(1);
    },

    dateClear() {
      this.dateSelect1 = "";
      this.dateSelect2 = "";
      this.alldate = "";
      this.loadGrid(1);
    },

    onPageChange(pageVal) {
      this.loadGrid(pageVal);
    },

    async openDetailPanel(item) {
      this.selectedClient = { ...item };
      if (!this.selectedClient.stage_wise_approval) {
        this.selectedClient.stage_wise_approval = {};
      }
      this.btmltab = 0;
      this.btmrtab = 0;
      this.lastActiveSide = "left";
      this.panrot = { rot: 0, flip: 1, pad: 0 };
      this.adharrot = { rot: 0, flip: 1, pad: 0 };
      this.bankrot = { rot: 0, flip: 1, pad: 0 };
      this.incrot = { rot: 0, flip: 1, pad: 0 };
      this.sigrot = { rot: 0, flip: 1, pad: 0 };
      this.pendingStagesAlert = [];
      this.detailDialog = true;

      const mobileNo = item.mobileNumber || item.mobile_no;
      if (mobileNo) {
        try {
          const res = await fetchClientData(mobileNo);
          const clientObj = res && res.data ? res.data : res && typeof res === "object" ? res : null;
          if (clientObj && (clientObj.mobileNumber || clientObj.mobile_no || clientObj.plan)) {
            this.selectedClient = { ...this.selectedClient, ...clientObj };
            if (!this.selectedClient.stage_wise_approval) {
              this.selectedClient.stage_wise_approval = {};
            }
          }
        } catch (err) {
          console.error("Failed to fetch client_data:", err);
        }
      }
    },

    async refreshDetailClient() {
      if (!this.selectedClient) return;
      const mobileNo = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;
      if (!mobileNo) {
        this.showToast("Mobile number unavailable to refresh", "warning");
        return;
      }

      this.mainloader = true;
      try {
        const res = await fetchClientData(mobileNo);
        const clientObj = res && res.data ? res.data : res && typeof res === "object" ? res : null;
        if (clientObj && (clientObj.mobileNumber || clientObj.mobile_no || clientObj.plan)) {
          this.selectedClient = { ...this.selectedClient, ...clientObj };
          if (!this.selectedClient.stage_wise_approval) {
            this.selectedClient.stage_wise_approval = {};
          }
          this.showToast("Client details refreshed", "success");
        }
      } catch (err) {
        console.error("Failed to refresh client details:", err);
        this.showToast(err.message || "Failed to refresh client details", "error");
      } finally {
        this.mainloader = false;
      }
    },

    getStageValue(stageKey) {
      if (!this.selectedClient || !this.selectedClient.stage_wise_approval) {
        return "";
      }
      return this.selectedClient.stage_wise_approval[stageKey] || "";
    },

    getStageClass(stageKey) {
      const val = this.getStageValue(stageKey);
      if (val === "yes") return "stage_yes";
      if (val === "no") return "stage_no";
      return "";
    },

    // Class for paired tabs (data + proof): red if EITHER is rejected, so the
    // data tab and its proof tab always reflect each other's rejection.
    getPairStageClass(stageKey) {
      const group = this.getStageGroup(stageKey);
      const vals = group.map((k) => this.getStageValue(k));
      if (vals.includes("no")) return "stage_no";
      if (this.getStageValue(stageKey) === "yes") return "stage_yes";
      return "";
    },

    // Slider (underline) color for a stage key, group-aware: red if the pair is
    // rejected, green if approved, else default.
    groupStatusColor(stageKey) {
      if (!stageKey) return "";
      const group = this.getStageGroup(stageKey);
      const vals = group.map((k) => this.getStageValue(k));
      if (vals.includes("no")) return "#FF1717";
      if (this.getStageValue(stageKey) === "yes") return "#43A833";
      return "";
    },

    // Class for the e-sign / agreement tabs: red only when app is rejected
    getAgreementTabClass() {
      return this.appRejected ? "stage_no" : "";
    },

    getStageLabel(stageKey) {
      const match = this.stageDefs.find((s) => s.key === stageKey);
      return match ? match.label : stageKey;
    },

    formatAppStatus(status) {
      if (!status) return "pending";
      const str = String(status).trim().toLowerCase();
      if (str === "in progress" || str === "in-progress" || str === "in_progress" || str === "file") {
        return "pending";
      }
      return status;
    },

    onLeftTabChange(val) {
      this.lastActiveSide = "left";
      switch (val) {
        case 0:
        case 1:
          this.btmrtab = 0; // e-sign document
          break;
        case 2:
          this.btmrtab = 4; // PAN proof
          break;
        case 3:
          this.btmrtab = 5; // Aadhar proof
          break;
        case 4:
          this.btmrtab = 6; // Bank proof
          break;
        case 5:
          this.btmrtab = 7; // Education proof
          break;
        case 6:
          this.btmrtab = 0; // Branch -> e-sign document
          break;
        default:
          this.btmrtab = 0;
      }
    },

    onRightTabChange(val) {
      this.lastActiveSide = "right";
      switch (val) {
        case 0:
          this.btmltab = 0; // e-sign document -> Mobile
          break;
        case 1:
        case 2:
        case 3:
          // NSE / BSE / MCX agreement -> keep current left tab
          break;
        case 4:
          this.btmltab = 2; // PAN proof -> PAN
          break;
        case 5:
          this.btmltab = 3; // Aadhar proof -> Verification
          break;
        case 6:
          this.btmltab = 4; // Bank proof -> Bank
          break;
        case 7:
          this.btmltab = 5; // Education proof -> Trading
          break;
        default:
          this.btmltab = 0;
      }
    },

    rotateImg(rotObj) {
      rotObj.rot = rotObj.rot !== 270 ? rotObj.rot + 90 : 0;
    },
    zoomInImg(rotObj) {
      rotObj.pad = rotObj.pad + 16;
    },
    zoomOutImg(rotObj) {
      if (rotObj.pad !== 0) rotObj.pad = rotObj.pad - 16;
    },
    flipImg(rotObj) {
      rotObj.flip = rotObj.flip === 0 ? 1 : 0;
    },
    resetImg(rotObj) {
      rotObj.rot = 0;
      rotObj.flip = 1;
      rotObj.pad = 0;
    },
    getImageStyle(rotObj) {
      return `transform: rotate(${rotObj.rot}deg) scaleX(${rotObj.flip === 0 ? -1 : 1}) !important; padding: ${rotObj.pad / 3}px ${rotObj.pad}px !important; ${
        rotObj.rot === 90 || rotObj.rot === 270 ? 'height:calc(100vh - 160px) !important;' : ''
      }`;
    },
    getImageWidth(rotObj) {
      return rotObj.rot === 0 || rotObj.rot === 180 ? '80%' : '100%';
    },
    isPdf(url) {
      if (!url) return false;
      return url.toLowerCase().includes(".pdf");
    },
    getFileUrl(pathStr) {
      if (!pathStr) return "";
      if (pathStr.startsWith("http://") || pathStr.startsWith("https://") || pathStr.startsWith("blob:")) {
        return pathStr;
      }
      return `${apApiBase}/file?path=${encodeURIComponent(pathStr)}`;
    },

    downloadFile() {
      const pdfPath = this.selectedClient ? (this.selectedClient.e_signed_pdf_path || this.selectedClient.panpdfloc || this.selectedClient.adhar_file) : "";
      if (pdfPath) {
        window.open(this.getFileUrl(pdfPath), "_blank");
      } else {
        this.showToast("No document available to download", "warning");
      }
    },

    // Stages that share a data + proof pair are updated together in a single API call
    getStageGroup(stageKey) {
      const groups = {
        pan: ["pan", "pan_proof"],
        pan_proof: ["pan", "pan_proof"],
        bank: ["bank", "bank_proof"],
        bank_proof: ["bank", "bank_proof"],
        trading: ["trading", "education_proof"],
        education_proof: ["trading", "education_proof"],
      };
      return groups[stageKey] || [stageKey];
    },

    async onApproveStage(stageKey) {
      if (!stageKey) {
        this.showToast("No stage active to approve", "warning");
        return;
      }
      this.updatingStageKey = stageKey;
      this.updatingStageVal = "yes";
      const mobileNo = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;
      const group = this.getStageGroup(stageKey);

      try {
        const updatedStageApproval = await updateStageApproval({
          mobileNo,
          stage: group,
          value: group.map(() => "yes"),
          reason: "",
        });

        this.selectedClient.stage_wise_approval = { ...updatedStageApproval };
        this.pendingStagesAlert = this.pendingStagesAlert.filter((k) => !group.includes(k));
        this.showToast(`Stage "${this.getStageLabel(stageKey)}" approved`, "success");
        await this.refreshDetailClient();
        // refresh dashboard grid + counts to reflect the stage change
        await this.loadGrid(this.page);
      } catch (err) {
        console.error("Error approving stage:", err);
        this.showToast(err.message || "Failed to approve stage", "error");
      } finally {
        this.updatingStageKey = "";
        this.updatingStageVal = "";
      }
    },

    async resetCurrentStage() {
      if (!this.currentStageKey) return;
      const stageKey = this.currentStageKey;
      this.updatingStageKey = stageKey;
      const mobileNo = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;
      const group = this.getStageGroup(stageKey);

      try {
        const updatedStageApproval = await updateStageApproval({
          mobileNo,
          stage: group,
          value: group.map(() => ""),
          reason: "",
        });

        this.selectedClient.stage_wise_approval = { ...updatedStageApproval };
        this.showToast(`Stage "${this.getStageLabel(stageKey)}" restored to pending`, "info");
        await this.refreshDetailClient();
        // refresh dashboard grid + counts to reflect the stage change
        await this.loadGrid(this.page);
      } catch (err) {
        console.error("Error resetting stage:", err);
        this.showToast(err.message || "Failed to reset stage", "error");
      } finally {
        this.updatingStageKey = "";
      }
    },

    promptRejectStage(stageKey) {
      if (!stageKey) {
        this.showToast("No stage active to reject", "warning");
        return;
      }
      this.activeStageKey = stageKey;
      this.stageRejectReason = "";
      this.stageRejectError = "";

      if (stageKey === "pan" || stageKey === "pan_proof") {
        this.rejectStageOptions = [
          { key: "pan", label: "Select if you reject PAN data" },
          { key: "pan_proof", label: "Select if you reject PAN proof" },
        ];
        this.selectedRejectStages = [stageKey];
      } else if (stageKey === "bank" || stageKey === "bank_proof") {
        this.rejectStageOptions = [
          { key: "bank", label: "Select if you reject Bank data" },
          { key: "bank_proof", label: "Select if you reject Bank proof" },
        ];
        this.selectedRejectStages = [stageKey];
      } else if (stageKey === "trading" || stageKey === "education_proof") {
        this.rejectStageOptions = [
          { key: "trading", label: "Select if you reject Trading data" },
          { key: "education_proof", label: "Select if you reject Education proof" },
        ];
        this.selectedRejectStages = [stageKey];
      } else {
        this.rejectStageOptions = [
          { key: stageKey, label: this.getStageLabel(stageKey) },
        ];
        this.selectedRejectStages = [stageKey];
      }

      this.stageRejectDialog = true;
    },

    async submitStageReject() {
      if (!this.stageRejectReason.trim()) {
        this.stageRejectError = "Reason is required";
        return;
      }
      if (!this.selectedRejectStages || this.selectedRejectStages.length === 0) {
        this.stageRejectError = "Select at least one stage to reject";
        return;
      }
      this.stageRejectError = "";
      this.updatingStageKey = this.activeStageKey;
      this.updatingStageVal = "no";
      const mobileNo = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;

      try {
        const stages = [...this.selectedRejectStages];
        const updatedStageApproval = await updateStageApproval({
          mobileNo,
          stage: stages,
          value: stages.map(() => "no"),
          reason: this.stageRejectReason.trim(),
        });
        this.selectedClient.stage_wise_approval = { ...updatedStageApproval };

        this.stageRejectDialog = false;
        this.showToast("Stage(s) rejected successfully", "error");
        await this.refreshDetailClient();
        // refresh dashboard grid + counts to reflect the stage change
        await this.loadGrid(this.page);
      } catch (err) {
        console.error("Error rejecting stage:", err);
        this.showToast(err.message || "Failed to reject stage", "error");
      } finally {
        this.updatingStageKey = "";
        this.updatingStageVal = "";
      }
    },

    async onApproveApplication() {
      this.updatingStatus = true;
      this.pendingStagesAlert = [];
      const mobileNo = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;

      try {
        const res = await updateApplicationStatus({
          mobileNo,
          status: "approved",
        });

        this.selectedClient.app_status = "approved";
        this.showToast(res.msg || "Application approved!", "success");
        // refresh the dashboard grid + counts to reflect the new status
        await this.loadGrid(this.page);
      } catch (err) {
        console.error("Error approving application:", err);
        const resp = err.responseData || {};
        if (resp.pending_stages && Array.isArray(resp.pending_stages)) {
          this.pendingStagesAlert = resp.pending_stages;
          this.showToast(resp.msg || "Please approve all stages first", "warning");
        } else {
          this.showToast(err.message || "Failed to approve application", "error");
        }
      } finally {
        this.updatingStatus = false;
      }
    },

    promptRejectApplication() {
      this.appRejectReason = "";
      this.appRejectError = "";
      this.appRejectDialog = true;
    },

    async onRestoreApplication() {
      this.switchingStatus = true;
      const mobileNo = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;
      const sw = this.selectedClient.stage_wise_approval || {};

      // status_switch expects this exact stages shape
      const stages = {
        mobile: sw.mobile || "",
        email: sw.email || "",
        pan: sw.pan || "",
        digilocker: sw.digilocker || "",
        personal: sw.personal || "",
        bank: sw.bank || "",
        segment: sw.segment || "",
        signature: sw.signature || "",
        selfie: sw.selfie || "",
        nominee: sw.nominee || "",
        bankproof: sw.bank_proof || sw.bankproof || "",
        panproof: sw.pan_proof || sw.panproof || "",
      };

      try {
        const res = await switchApplicationStatus({ mobileNo, stages });
        this.showToast(res.msg || "Application restored", "success");
        this.detailDialog = false;
        // refresh the dashboard grid + counts to reflect the switched status
        await this.loadGrid(this.page);
      } catch (err) {
        console.error("Error switching application status:", err);
        this.showToast(err.message || "Failed to restore application", "error");
      } finally {
        this.switchingStatus = false;
      }
    },

    async submitApplicationReject() {
      if (!this.appRejectReason.trim()) {
        this.appRejectError = "Reason is required";
        return;
      }
      this.appRejectError = "";
      this.updatingStatus = true;
      const mobileNo = this.selectedClient.mobileNumber || this.selectedClient.mobile_no;

      try {
        const res = await updateApplicationStatus({
          mobileNo,
          status: "rejected",
          rejected_reason: this.appRejectReason.trim(),
        });

        this.selectedClient.app_status = "rejected";
        this.selectedClient.rejected_reason = this.appRejectReason.trim();
        this.appRejectDialog = false;
        this.showToast(res.msg || "Application rejected", "error");
        // refresh the dashboard grid + counts to reflect the new status
        await this.loadGrid(this.page);
      } catch (err) {
        console.error("Error rejecting application:", err);
        this.showToast(err.message || "Failed to reject application", "error");
      } finally {
        this.updatingStatus = false;
      }
    },

    promptDelete(item) {
      this.deleteTarget = { ...item };
      this.deleteReason = "";
      this.deleteError = "";
      this.deleteDialog = true;
    },

    async confirmDelete() {
      if (!this.deleteTarget) return;
      if (!this.deleteReason.trim()) {
        this.deleteError = "Reason is required";
        return;
      }
      this.deleteError = "";
      const mobileNo = this.deleteTarget.mobileNumber || this.deleteTarget.mobile_no;
      if (!mobileNo) {
        this.showToast("Mobile number unavailable to delete", "warning");
        return;
      }
      this.deleteBtnLoading = true;

      try {
        const res = await deleteClient({ mobileNo, reason: this.deleteReason.trim() });
        this.deleteDialog = false;
        this.showToast(res.msg || "Deleted successfully", "success");
        // record removed server-side, so refresh grid + counts
        await this.loadGrid(this.page);
      } catch (err) {
        console.error("Error deleting application:", err);
        if (err.status === 404) {
          // already deleted / invalid mobile -> refresh list
          this.deleteDialog = false;
          this.showToast(err.message || "User not found", "warning");
          await this.loadGrid(this.page);
        } else {
          this.showToast(err.message || "Failed to delete application", "error");
        }
      } finally {
        this.deleteBtnLoading = false;
      }
    },

    // ---------- Sharing Ratio tab (adapted from ShareGen) ----------
    srInitialize() {
      this.sr_desserts = [
        { sharing_seg: "Equities Intraday", ap_sharing: "70%", zebu_sharing: "30%", min_to_zebu: "300/cr" },
        { sharing_seg: "Equities Delivery", ap_sharing: "70%", zebu_sharing: "30%", min_to_zebu: "3000/cr" },
        { sharing_seg: "Futures FNO,CDS,COM", ap_sharing: "70%", zebu_sharing: "30%", min_to_zebu: "300/cr" },
        { sharing_seg: "Options FNO,CDS,COM", ap_sharing: "-", zebu_sharing: "-", min_to_zebu: "Rs. 5" },
      ];
    },

    async srLoadBranchCodes() {
      this.sr_branchLoading = true;
      try {
        const res = await axios.post(`${apApiBase.replace(/\/$/, "")}/get_branch_code`);
        this.sr_branchItems = (res.data && res.data.data) || [];
      } catch (err) {
        console.error("Failed to fetch branch codes:", err);
        this.showToast("Failed to fetch branch codes", "error");
      } finally {
        this.sr_branchLoading = false;
      }
    },

    srEditItem(item, title) {
      if (title[0] == "Equities") {
        this.sr_formTitle = title[0] + " " + title[1];
      } else {
        this.sr_formTitle = title[0];
      }

      if (title[0] != "Options") {
        this.sr_editZebuSharing = item.zebu_sharing;
        this.sr_editMinToZebu = item.min_to_zebu;
      } else {
        const zebuStr = item.zebu_sharing ? item.zebu_sharing.toString() : "";
        const minStr = item.min_to_zebu ? item.min_to_zebu.toString() : "";
        const isPercentageMode = zebuStr.includes("%");

        this.sr_optionsType = isPercentageMode ? 1 : 0;

        this.$nextTick(() => {
          if (isPercentageMode) {
            this.sr_editZebuSharing = zebuStr;
            this.sr_editApSharing = null;
          } else {
            this.sr_editApSharing = "-";
            this.sr_editZebuSharing = "-";
          }

          if (minStr.includes("Rs.")) {
            this.sr_editMinToZebu = parseInt(minStr.replace("Rs.", "").trim());
          } else {
            this.sr_editMinToZebu = 5;
          }
        });
      }

      this.sr_editedIndex = this.sr_desserts.indexOf(item);
      this.sr_dialog = true;
    },

    srClose() {
      this.sr_dialog = false;
      this.$nextTick(() => {
        this.sr_editedIndex = -1;
      });
    },

    srSave() {
      let title = this.sr_formTitle;
      if (title == "Options" || title == "Futures") {
        title = title + " FNO,CDS,COM";
      }
      for (let i = 0; i < this.sr_desserts.length; i++) {
        if (this.sr_desserts[i].sharing_seg == title) {
          if (this.sr_formTitle != "Options") {
            this.sr_desserts[i].zebu_sharing = this.sr_editZebuSharing;
            this.sr_desserts[i].ap_sharing = (100 - parseInt(this.sr_editZebuSharing.split("%")[0])).toString() + "%";
            this.sr_desserts[i].min_to_zebu = this.sr_editMinToZebu;
            this.srClose();
          } else if (this.sr_optionsType == 1 && this.sr_editMinToZebu >= 5 && this.sr_editMinToZebu <= 50) {
            this.sr_desserts[i].zebu_sharing = this.sr_editZebuSharing;
            this.sr_desserts[i].ap_sharing = (100 - parseInt(this.sr_editZebuSharing.toString().split("%")[0])).toString() + "%";
            this.sr_desserts[i].min_to_zebu = "Rs. " + this.sr_editMinToZebu.toString();
            this.srClose();
          } else if (
            this.sr_optionsType == 0 &&
            Number(this.sr_editMinToZebu) >= 5 && Number(this.sr_editMinToZebu) <= 50
          ) {
            this.sr_desserts[i].zebu_sharing = "-";
            this.sr_desserts[i].ap_sharing = "-";
            this.sr_desserts[i].min_to_zebu = "Rs. " + this.sr_editMinToZebu.toString();
            this.srClose();
          }
        }
      }
    },

    // Encode the current editable plan into the base64 code the backend expects:
    // base64( JSON(sharing rows) $ <branch_code> $ <client_type> )
    srEncodePlan() {
      const payload = JSON.stringify(this.sr_desserts) + "$" + this.sr_branch + "$" + this.sr_clientType;
      return btoa(unescape(encodeURIComponent(payload)));
    },

    // Group flat plan rows by their leading category (Equities / Futures / Options)
    buildPlanGroups(list) {
      const groups = [];
      const map = {};
      (list || []).forEach((row) => {
        const seg = String(row.sharing_seg || "").trim();
        if (!seg) return;
        const spaceIdx = seg.indexOf(" ");
        const title = spaceIdx === -1 ? seg : seg.slice(0, spaceIdx);
        const label = spaceIdx === -1 ? seg : seg.slice(spaceIdx + 1).trim();
        if (!map[title]) {
          map[title] = { title, rows: [] };
          groups.push(map[title]);
        }
        map[title].rows.push({
          label,
          ap_sharing: row.ap_sharing,
          zebu_sharing: row.zebu_sharing,
          min_to_zebu: row.min_to_zebu,
        });
      });
      return groups;
    },

    // Decode a base64 "<b64 JSON>$branch$member" plan into { list, branch, member, raw }
    decodePlanString(rawPlan) {
      if (!rawPlan) return { list: [], branch: "", member: "", raw: "" };

      if (Array.isArray(rawPlan)) {
        return { list: rawPlan, branch: "", member: "", raw: "" };
      }
      if (typeof rawPlan === "object") {
        return { list: [rawPlan], branch: "", member: "", raw: "" };
      }

      let str = String(rawPlan).trim();
      let branch = "";
      let member = "";

      if (str.includes("$")) {
        const parts = str.split("$");
        if (parts[0].startsWith("W3") || parts[0].startsWith("ey")) {
          str = parts[0];
        }
        if (parts.length > 1 && parts[1]) branch = parts[1];
        if (parts.length > 2 && parts[2]) member = parts[2];
      }

      // Direct JSON parse attempt
      try {
        const direct = JSON.parse(str);
        if (Array.isArray(direct)) return { list: direct, branch, member, raw: str };
        if (typeof direct === "object" && direct !== null) return { list: [direct], branch, member, raw: str };
      } catch (e) {
        // Continue
      }

      // Base64 decode attempt
      try {
        let b64 = str.replace(/\s+/g, "").replace(/-/g, "+").replace(/_/g, "/");
        while (b64.length % 4 !== 0) {
          b64 += "=";
        }

        let decoded = "";
        try {
          decoded = atob(b64);
        } catch (e1) {
          decoded = decodeURIComponent(
            atob(b64)
              .split("")
              .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
              .join("")
          );
        }

        // Find JSON array bounds inside decoded text
        const firstBracket = decoded.indexOf("[");
        const lastBracket = decoded.lastIndexOf("]");
        if (firstBracket !== -1 && lastBracket > firstBracket) {
          const jsonPart = decoded.substring(firstBracket, lastBracket + 1);
          const list = JSON.parse(jsonPart);

          const suffix = decoded.substring(lastBracket + 1);
          if (suffix.includes("$")) {
            const sParts = suffix.split("$");
            if (sParts[1]) branch = sParts[1];
            if (sParts[2]) member = sParts[2];
          }

          return {
            list: Array.isArray(list) ? list : [list],
            branch,
            member,
            raw: str,
          };
        }

        // Fallback if no brackets
        const list = JSON.parse(decoded);
        return {
          list: Array.isArray(list) ? list : [list],
          branch,
          member,
          raw: str,
        };
      } catch (err) {
        console.error("Base64 plan parse error:", err, "raw:", str);
        return { list: [], branch, member, raw: str };
      }
    },

    // API status value — sent as-is (complete | pending)
    rbApiStatus() {
      return this.rb_status;
    },

    async rbGetPlan() {
      if (!this.rb_mobile || !this.rb_status) return;
      this.rb_fetchLoading = true;
      this.rb_planFetched = false;
      this.rb_pan = "";
      this.rb_panName = "";
      this.rb_clientId = "";
      this.rb_appStatus = "";
      this.rb_branchCode = "";
      this.rb_masterCode = "";
      this.rb_managerName = "";
      this.rb_managerMail = "";
      this.rb_managerContact = "";

      try {
        // make sure the Branch Code select has options to show the fetched branch
        if (!this.sr_branchItems.length) await this.srLoadBranchCodes();

        const res = await axios.get(`${apApiBase.replace(/\/$/, "")}/getPlan`, {
          params: { mobile_no: this.rb_mobile, status: this.rbApiStatus() },
        });
        const data = res.data || {};

        if (Object.prototype.hasOwnProperty.call(data, "plan")) {
          // extra client details (shown as "-" when empty)
          this.rb_pan = data.pan || "";
          this.rb_panName = data.pan_name || "";
          this.rb_clientId = data.client_id || "";
          this.rb_appStatus = data.app_status || "";
          // branch details
          this.rb_branchCode = data.branch_code || "";
          this.rb_masterCode = data.master_code || "";
          this.rb_managerName = data.manager_name || "";
          this.rb_managerMail = data.manager_mail || "";
          this.rb_managerContact = data.manager_contact || "";

          const decoded = this.decodePlanString(data.plan || "");

          // Load the plan into the editable table so it can be edited before update
          if (decoded.list && decoded.list.length) {
            this.sr_desserts = decoded.list;
          } else {
            this.srInitialize();
            this.showToast("Plan is empty; showing a default plan to edit", "warning");
          }

          // Reflect the decoded branch / client type in the selectors
          if (decoded.branch) {
            if (!this.sr_branchItems.includes(decoded.branch)) this.sr_branchItems.push(decoded.branch);
            this.sr_branch = decoded.branch;
          }
          if (decoded.member) {
            if (!this.sr_clientTypeItems.includes(decoded.member)) this.sr_clientTypeItems.push(decoded.member);
            this.sr_clientType = decoded.member;
          }

          this.rb_planFetched = true;
        } else {
          this.showToast(data.msg || "No data found", "warning");
        }
      } catch (err) {
        console.error("Failed to fetch plan:", err);
        const errData = err.response ? err.response.data : {};
        this.showToast(errData.msg || err.message || "Failed to fetch plan", "error");
      } finally {
        this.rb_fetchLoading = false;
      }
    },

    async rbUpdateBranch() {
      if (!this.rb_mobile || !this.sr_branch || !this.sr_clientType) return;
      this.rb_updateLoading = true;

      try {
        // encode the (possibly edited) plan back into the base64 code the API decodes
        const plan = this.srEncodePlan();
        const res = await axios.post(
          `${apApiBase.replace(/\/$/, "")}/updateBranch`,
          {},
          { params: { mobile_no: this.rb_mobile, plan, status: this.rbApiStatus() } }
        );
        const msg = (res.data && res.data.msg) || "";
        if (msg.toLowerCase() === "updated successfully") {
          this.showToast(msg, "success");
          // status may change (re-e-signed pending) — refresh the grid + counts
          await this.loadGrid(this.page);
        } else {
          // "No data found" / "Error" come back with HTTP 200
          this.showToast(msg || "No data found", "warning");
        }
      } catch (err) {
        console.error("Failed to update branch:", err);
        const errData = err.response ? err.response.data : {};
        this.showToast(errData.msg || err.message || "Failed to update branch", "error");
      } finally {
        this.rb_updateLoading = false;
      }
    },
  },
};
</script>

<style>
@import "../assets/style.css";

code {
  font-size: 11px;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  color: #475569;
}

/* Align Sharing Plan panels to the far left with the other fields */
.plan-panels .v-expansion-panel-header {
  padding-left: 0;
}
.plan-panels .v-expansion-panel-content__wrap {
  padding-left: 0;
  padding-right: 0;
}

/* Bordered grid for the Sharing Plan tables */
.plan-bordered-table table {
  border: thin solid #e0e0e0;
  border-collapse: collapse;
}
.plan-bordered-table th,
.plan-bordered-table td {
  border: thin solid #e0e0e0 !important;
}

/* Re-assign Branch: section title + icon-tile detail grid */
.rb-section-title {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #78909c;
  margin-bottom: 12px;
}
.rb-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}
.rb-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid #eef1f6;
  border-radius: 10px;
  background: #fff;
}
.rb-info .rb-ic {
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 8px;
  background: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rb-info-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.rb-info-label {
  font-size: 0.68rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #90a4ae;
  margin-bottom: 2px;
}
.rb-info-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1a1a1a;
  word-break: break-word;
}

/* Sharing Ratio: roomier, more legible plan table */
.sr-plan-table th {
  height: 52px !important;
  font-size: 0.8rem !important;
}
.sr-plan-table td {
  height: 62px !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  font-size: 0.95rem !important;
}
.sr-plan-table tbody tr:not(:last-child) td {
  border-bottom: thin solid #eeeeee;
}
.sr-plan-table .sr-seg-name {
  font-size: 1rem !important;
}
.sr-plan-table .sr-seg-sub {
  font-size: 0.8rem !important;
}

/* Sharing Ratio: Lot / Percentage toggle (theme-matched) */
.sr-options-toggle {
  background-color: transparent !important;
  border-radius: 6px !important;
  gap: 8px;
}
.sr-options-toggle .sr-toggle-btn {
  border: 1px solid #e0e0e0 !important;
  border-radius: 6px !important;
  background-color: #ffffff !important;
  color: #555 !important;
  text-transform: none !important;
  letter-spacing: 0;
  font-weight: 500;
  box-shadow: none !important;
  height: 32px !important;
  padding: 0 16px !important;
  opacity: 1 !important;
}
.sr-options-toggle .sr-toggle-btn.v-btn--active {
  border: 1px solid #0037b7 !important;
  background-color: #e8effb !important;
  color: #0037b7 !important;
}
.sr-options-toggle .sr-toggle-btn.v-btn--active::before {
  opacity: 0 !important;
}
</style>
